// imports
import ReportIncidentsModel from '$models/ReportIncidentsModel';
import incidentDrupalFilterParent from '$models/incidents/incidentDrupalFilterParent';
import MMCollection from './MMCollection';

const filterDictionary = {
	post_code: 'field_incident_post_code',
	status: 'field_incident_status',
	volume: 'field_incident_volume',
	team: 'field_incident_team',
	bin_hasremarks: 'field_incident_bin_hasremarks',
};

// class definition
export default class ReportIncidentsCollection extends MMCollection {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.Model = args.Model || ReportIncidentsModel;
		args.parentModel = incidentDrupalFilterParent();
		args.useProQueryParams = true;
		args.dictionary = filterDictionary;
		args.filterDictionary = filterDictionary;
		// call super constructor
		super(args);
	}

	parse(data) {
		return super.parse(data);
	}
}
